import { useAuth } from '../lib/auth'
import { Logo } from '../platform/branding/Logo'
import { useT } from '../i18n'

interface Props {
  /** What the user was trying to do — "play games", "vote", etc. */
  action?: string
  /** Optional longer explanation line. */
  detail?: string
  /** Optional back button target; usually back to the weekly hub. */
  onBack?: () => void
}

/**
 * Full-screen "you need to sign in" gate. Shown when a guest tries to
 * access an authenticated-only flow. One tap exits guest mode — the
 * parent `<App>` then renders the real `<AuthScreen>`.
 */
export function SignInRequired({ action = 'continue', detail, onBack }: Props) {
  const t = useT()
  const { exitGuestMode } = useAuth()

  return (
    <div className="screen px-6 justify-center text-center">
      <div className="max-w-sm mx-auto w-full space-y-6">
        <Logo size={64} className="mx-auto" />

        <div>
          <h1 className="font-display text-2xl font-bold text-brand-text uppercase tracking-wide">
            Sign in to {action}
          </h1>
          <p className="text-brand-muted mt-2 text-sm">
            {detail ?? t('Only signed-in players can play games, submit a dish, or vote on the weekly event.')}
          </p>
        </div>

        <button onClick={exitGuestMode} className="btn-primary">{t('Sign in')}</button>

        {onBack && (
          <button onClick={onBack} className="btn-ghost w-full">
            ← Back
          </button>
        )}
      </div>
    </div>
  )
}
